import React, { useState } from 'react';

const FAQS = [
  {
    question: 'Como devo usar?',
    answer: 'Tome 20 gotas sublinguais pela manhã, cerca de 30 minutos antes da sua principal refeição (preferencialmente o almoço). Essa forma de uso garante melhor absorção e potencializa os resultados.'
  },
  {
    question: 'Preciso fazer dieta?',
    answer: 'Você não precisa passar fome! O Magrisim reduz o apetite, controla a compulsão alimentar e proporciona saciedade prolongada.'
  },
  {
    question: 'Lactante pode tomar?',
    answer: 'O uso é recomendado apenas após o bebê completar 6 meses, quando inicia a introdução alimentar. Até lá, a amamentação exclusiva é recomendada pela Organização Mundial da Saúde (OMS) devido aos benefícios nutricionais e imunológicos do leite materno.'
  },
  {
    question: 'Grávida pode tomar?',
    answer: 'Não. Mesmo sendo natural, nenhum produto para emagrecimento deve ser usado durante a gestação. O foco nesse período deve ser nutrição adequada.'
  },
  {
    question: 'A partir de que idade pode tomar?',
    answer: 'O uso é indicado a partir dos 18 anos, quando o corpo já completou a fase de crescimento e desenvolvimento.'
  },
  {
    question: 'Vou sentir efeitos colaterais?',
    answer: 'A fórmula é 100% natural, livre de cafeína e de substâncias que possam agredir fígado ou rins. Em geral, não há efeitos colaterais.'
  },
  {
    question: 'Quanto tempo demora para entregar?',
    answer: 'O prazo médio de entrega do MagriSim para o Brasil é de até 10 dias úteis. Em 90% dos casos a entrega é realizada antes de 7 dias. O produto só é enviado após a confirmação do seu pagamento pela administradora do seu cartão de crédito ou após a confirmação de pagamento do boleto.'
  },
  {
    question: 'Posso continuar tomando mesmo depois de emagrecer?',
    answer: 'Sim! O Magrisim é seguro para uso prolongado e pode ser mantido como aliado na manutenção do peso e no controle do apetite. Não há restrição de tempo para uso.'
  }
];

const FaqSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (i) => setOpenIndex((prev) => (prev === i ? null : i));

  return (
    <section id="faq" className="mgs-faq">
      <div className="mgs-faq__inner">
        <h2 className="mgs-faq__title">
          Acabe com as suas <span className="mgs-faq__title-gold">dúvidas!</span>
        </h2>

        <div className="mgs-faq__list">
          {FAQS.map((faq, i) => {
            const open = openIndex === i;
            return (
              <div key={i} className={`mgs-faq__item${open ? ' is-open' : ''}`}>
                <button
                  type="button"
                  className="mgs-faq__q"
                  onClick={() => toggle(i)}
                  aria-expanded={open}
                >
                  <span>{faq.question}</span>
                  <i className={`fas ${open ? 'fa-minus' : 'fa-plus'}`}></i>
                </button>
                <div className="mgs-faq__a" aria-hidden={!open}>
                  <p>{faq.answer}</p>
                </div>
              </div>
            );
          })}
        </div>

        {/* Falar com atendente */}
        <div className="mgs-faq__contact">
          <h3 className="mgs-faq__contact-title">
            Gostaria de falar com uma de nossas atendentes?
          </h3>
          <a
            href="https://wa.me/553135687051?text=Olá! Gostaria de saber mais sobre o Magrisim!"
            target="_blank"
            rel="noopener noreferrer"
            className="mgs-faq__whatsapp"
          >
            <i className="fab fa-whatsapp"></i>
            Falar com atendente
          </a>
          <p className="mgs-faq__contact-note">
            Basta clicar no botão acima para falar via WhatsApp!
          </p>
        </div>

      </div>
    </section>
  );
};

export default FaqSection;
